<template>
  <!-- 三级菜单缓存 保留各组件 模糊搜索 jia -->
  <keep-alive :include="tagListComputed">
    <router-view/>
  </keep-alive>
</template>

<script>
export default {
  computed: {
    tagListComputed() {
      let temp = this.$store.getters.tagList.map(item => item.value)
      let temp1 = []
      temp.forEach(item => {
        let split = item.split('/')
        split = split.reverse()
        temp1.push(split[1])
      })
      console.log(temp1, '不销毁组件')
      return temp1
    }
  },
}
</script>
